import { z } from "zod";
import {
  OutboundTransportSchema,
  OutboundDeliveryProviderSchema,
} from "../schemas/EmailRoutingSchema";
export const OutboundTransportSenderSchema = z
  .object({
    provider: OutboundDeliveryProviderSchema,
    fromEmail: z.string().email().max(320),
    fromName: z.string().max(500).optional(),
    replyToEmail: z.string().email().max(320).optional(),
  })
  .strict();
export const OutboundTransportCandidateSchema = z.discriminatedUnion(
  "available",
  [
    z
      .object({
        transport: OutboundTransportSchema,
        available: z.literal(true),
        sender: OutboundTransportSenderSchema,
      })
      .strict(),
    z
      .object({
        transport: OutboundTransportSchema,
        available: z.literal(false),
        reasonCode: z.string().regex(/^[A-Z][A-Z0-9_]{0,127}$/),
      })
      .strict(),
  ],
);
export const OutboundTransportSelectionSchema = z
  .object({
    tenantId: z.string().regex(/^[A-Za-z0-9_-]{1,128}$/),
    currentTransport: OutboundTransportSchema,
    revision: z.string().regex(/^[a-f0-9]{64}$/),
    candidates: z.array(OutboundTransportCandidateSchema).length(4),
  })
  .strict()
  .superRefine((value, ctx) => {
    for (const [index, candidate] of value.candidates.entries()) {
      if (
        candidate.available &&
        ((candidate.transport === "SMTP" &&
          candidate.sender.provider !== "SMTP") ||
          (candidate.transport.startsWith("MICROSOFT_GRAPH_") &&
            candidate.sender.provider !== "MICROSOFT_GRAPH") ||
          (candidate.transport === "PLATFORM" &&
            !["CLOUDFLARE", "BREVO", "RESEND"].includes(
              candidate.sender.provider,
            )))
      )
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["candidates", index, "sender", "provider"],
          message: "Sender provider contradicts transport",
        });
    }
    if (new Set(value.candidates.map((c) => c.transport)).size !== 4)
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Each transport must appear once",
      });
  });
export const SelectOutboundTransportCommandSchema = z
  .object({
    selectedTransport: OutboundTransportSchema,
    expectedRevision: z.string().regex(/^[a-f0-9]{64}$/),
  })
  .strict();
export type OutboundTransportSelection = z.infer<
  typeof OutboundTransportSelectionSchema
>;
export type OutboundTransportCandidate = z.infer<
  typeof OutboundTransportCandidateSchema
>;
export type OutboundTransportSender = z.infer<
  typeof OutboundTransportSenderSchema
>;
export type SelectOutboundTransportCommand = z.infer<
  typeof SelectOutboundTransportCommandSchema
>;
